module.exports = __webpack_public_path__ + "static/img/yixi-logo.46c85c00.jpg";